import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b4ea40f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-line" }
const _hoisted_2 = { class: "progress-line__description mb--5" }
const _hoisted_3 = { class: "progress-line__description-value main-color" }
const _hoisted_4 = { class: "progress-line__linear" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseProgressLine',
  props: {
    value: { default: '' },
    name: {}
  },
  setup(__props: any) {

const props = __props;
const cssProps = computed(() => {
  return {
    width: `100%`,
  };
});

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_ctx.name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_icon, {
          color: "#009D3E",
          "font-size": "20",
          name: "check",
          width: "22"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", {
        style: _normalizeStyle(cssProps.value)
      }, null, 4)
    ])
  ]))
}
}

})